export enum SurveyQuestionType {
    Undefined = 0,
    FreeText = 1,
    SingleSelect = 2,
    MultipleSelect = 3,
    Score = 4,
    NPS = 5,
    TagCloud = 6
}
